import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row, Table, Button } from "reactstrap";
import "./MomDiary.scss";
import { getMomDiary, downloadMomDiary, deleteMomDiary } from '../../services';
import { downloadFile } from '../../../utils'
import { showSuccess, showConfirmation } from '../../../utils/alerts'
import Loader from "../../Loader";

class ViewmomDiary extends Component {
  state = {
    diaries: [],
    errormsg: "",
    successmsg: "",
    loading: true,
    found: false,
    _delete: false
  };

  componentDidMount() {

    getMomDiary()
      .then(({ data }) => {
        this.setState({
          diaries: data.diaries,
          loading: false,
          found: true,
          successmsg: data.message
        });
      })
      .catch(err => {
        this.setState({
          errormsg: err.message,
          loading: false
        });
      });
  }

  handleDownload = async (recordId) => {
    const data = {
      recordId
    }

    const response = await downloadMomDiary(data);

    downloadFile(response.data, "Diary");

    return;
  }

  handleDelete = async (_id) => {
    const result = await showConfirmation("Yes, delete it!")
    if(result.value == true) {
      await deleteMomDiary({data: {recordId: _id }});
      this.setState(prevState => ({
        diaries: prevState.diaries.filter((record) => record._id !== _id)
      }))
      await showSuccess("success", "Deleted!", "Your file has been deleted");
    }
  };

  render() {
    
    const { diaries } = this.state;

    if (this.state.loading) {
      return (
        <Loader />
      );
    }

    return (
      <div style={{ marginTop: "20px"}}>
        <Row>
          <Col xs="12" lg="12">
            <Card className="MomDiaryTableCard">
              <CardBody style={{ padding: 0 }}>
                { diaries.length > 0 ? <Table responsive>
                  <thead className="tableHeader">
                  <tr>
                    <th>S.No.</th>
                    <th>Title</th>
                    <th>Mood</th>
                    {/* <th>Image</th> */}
                    <th>Writtten on</th>
                    <th>Last Modified</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  {diaries.map((diary, index) => (
                      <tr onClick={(e) => console.log("abc")}>
                        <td>{index + 1}</td>
                        <td>{diary.title}</td>
                        <td>{diary.mood}</td>
                        <td>{diary.createdAt}</td>
                        <td>{diary.updatedAt}</td>
                        <td>                          
                          {/* <Link to={`/personalhealthrecord/editmomdiary/${diary._id}`}>
                            <i className="viewDiary fa fa-bars editable-icons" />
                          </Link> */}
                          <Link to={`/personalhealthrecord/editmomdiary/${diary._id}`}>
                            <i className="editDiary fa fa-pencil editable-icons" />
                          </Link>
                          <i className="downloadRecord fa fa-download editable-icons" 
                            onClick={() => this.handleDownload(diary._id)}
                          />
                          <i 
                            onClick={() => this.handleDelete(diary._id)}
                            className="deleteDiary fa fa-trash editable-icons"
                          />                          
                        </td>
                      </tr>
                  ))}
                  </tbody>
                </Table>
                : <div><h4>No records found</h4></div>}
              </CardBody>
            </Card>
            <div className="text-center">
              <Button
                className="btn text-center"
                tag={Link}
                to={"/personalhealthrecord/addmomdiary"}
              >
                Add New Diary Entry
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ViewmomDiary;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/MomDiary/ViewmomDiary.js